import React from 'react';
import { connect } from 'dva';
import { Layout, Form, Input, Table, Button, Checkbox, Modal, Collapse } from 'antd';
import debounce from 'lodash/debounce';
import AppIcon from '@/components/app-icon';
import InfoBar from '@/components/info-bar';
import SidePanel from '@/components/side-panel';
import EventDetails from './event-details';

const columns = [
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Start Time',
    dataIndex: 'startTime',
    key: 'startTime',
  },
  {
    title: 'End Time',
    dataIndex: 'endTime',
    key: 'endTime',
  },
  {
    title: 'Published',
    dataIndex: 'published',
    key: 'published',
    render: (checked) => (
      <Checkbox
        checked={checked}
        disabled
      />
    ),
  },
];

export const ROW_KEY = '_id';

class AdminEvent extends React.Component {
  state = {
    showModal: false,
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({ type: 'portalEventModel/getPortalEvents' });
  }

  showEventDetails = () => {
    this.setState({ showModal: true });
  };

  hideEventDetails = () => {
    this.setState({ showModal: false });
  };

  renderSider = () => {
    const {
      portalEventModel: { refineParams },
    } = this.props;

    return (
      <SidePanel type="filter">
        <Form
          layout="vertical"
          initialValues={refineParams}
          onValuesChange={debounce((_, values) => {
            this.props.dispatch({
              type: 'portalEventModel/getPortalEvents',
              payload: values,
            });
            this.props.dispatch({
              type: 'portalEventModel/setState',
              payload: {
                refineParams: values,
              },
            });
          }, 500)}
        >
          <Form.Item
            label="Title"
            name="title"
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Creator"
            name="creator"
          >
            <Input />
          </Form.Item>
          <Collapse
            ghost
            defaultActiveKey={['published']}
          >
            <Collapse.Panel
              header="Published"
              key="published"
            >
              <Form.Item name="published">
                <Checkbox.Group>
                  <Checkbox value={true}>Yes</Checkbox>
                  <Checkbox value={false}>No</Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </Collapse.Panel>
          </Collapse>
        </Form>
      </SidePanel>
    );
  };

  renderTableFooter = () => {
    const {
      portalEventModel: { currentEvent },
    } = this.props;

    return currentEvent[ROW_KEY] ? (
      <div className="table-footer">
        <div>1 selected</div>
        <div>
          <Button
            type="text"
            onClick={() => {
              Modal.confirm({
                title: 'Warning',
                content: 'This will remove event.',
                cancelButtonProps: { type: 'text' },
                onOk: () => {
                  this.props.dispatch({
                    type: 'portalEventModel/deletePortalEvents',
                  });
                },
              });
            }}
          >
            Delete
          </Button>
          <Button
            type="primary"
            onClick={this.showEventDetails}
          >
            Edit
          </Button>
        </div>
      </div>
    ) : null;
  };

  onCurrentEventChange = (record = {}) => {
    const {
      portalEventModel: { currentEvent },
      dispatch,
    } = this.props;

    const payload = record[ROW_KEY] === currentEvent[ROW_KEY] ? {} : record;
    dispatch({ type: 'portalEventModel/onCurrentEventChange', payload });
  };

  render() {
    const {
      portalEventModel: { loading, portalEvents, currentEvent },
      dispatch,
    } = this.props;
    const { showModal } = this.state;

    return (
      <div>
        <InfoBar
          icon="MCP_app_menu_Audit_logs"
          color="#8d6ccf"
          title="Event Management"
          subtitle="Manage the content that appears in the CEC"
          actions={[
            {
              label: 'New',
              icon: <AppIcon name="add" />,
              onClick: () => {
                this.onCurrentEventChange();
                this.showEventDetails();
              },
            },
          ]}
        />
        <Layout>
          {this.renderSider()}
          <Layout.Content className="page">
            <div className="table-container">
              <Table
                bordered
                size="small"
                rowKey={ROW_KEY}
                loading={loading}
                dataSource={portalEvents}
                columns={columns}
                rowSelection={{
                  hideSelectAll: true,
                  selectedRowKeys: [currentEvent[ROW_KEY]],
                  onChange: (_, selectedRows) => this.onCurrentEventChange(selectedRows[0]),
                }}
                onRow={(record) => ({
                  onClick: () => this.onCurrentEventChange(record),
                })}
                pagination={false}
              />
              {this.renderTableFooter()}
            </div>
          </Layout.Content>
        </Layout>
        {showModal && (
          <EventDetails
            onCancel={this.hideEventDetails}
            dispatch={dispatch}
            event={currentEvent}
          />
        )}
      </div>
    );
  }
}

export default connect(({ portalEventModel }) => ({
  portalEventModel,
}))(AdminEvent);
